module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": "",
      "fullscreen": _vm.isMobile
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.menuDateModel),
      callback: function($$v) {
        _vm.menuDateModel = $$v
      },
      expression: "menuDateModel"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "rules": [_vm.rules.date],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateModel),
      callback: function($$v) {
        _vm.dateModel = $$v
      },
      expression: "dateModel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.minDate,
      "scrollable": ""
    },
    model: {
      value: (_vm.dateModel),
      callback: function($$v) {
        _vm.dateModel = $$v
      },
      expression: "dateModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Time",
      "value": "12:30",
      "type": "time"
    },
    model: {
      value: (_vm.timeModel),
      callback: function($$v) {
        _vm.timeModel = $$v
      },
      expression: "timeModel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "New case name",
      "append-icon": "save"
    },
    model: {
      value: (_vm.caseName),
      callback: function($$v) {
        _vm.caseName = $$v
      },
      expression: "caseName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "error",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogModel = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.dateValidation(_vm.dateModel)) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "block": "",
      "loading": _vm.addLoading
    },
    on: {
      "click": _vm.saveNewCase
    }
  }, [_vm._v("Add case")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd168ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AddCaseNameAndDateDialog.vue
// module id = 969
// module chunks = 1